import clsx from "clsx";

import { formatPrice, formatTime } from "~/helpers/helpers";

import styles from "./BillingTotals.module.scss";

interface BillingTotalsProps {
  amountDue: number;
  total: number;
  crawlRanking: number;
  aiUsage: number;
  lastUpdate: string;
  fullWidth?: boolean;
}

interface TotalCardProps {
  title: string;
  value: number;
  lastUpdate: string;
  formatFn: (value: number) => string;
}

const TotalCard = ({ title, value, lastUpdate, formatFn }: TotalCardProps) => (
  // @ts-expect-error TS2551 non-existing className
  <div className={styles.totals__card}>
    {/*
     // @ts-expect-error TS2551 non-existing className */}
    <h2 className={styles.totals__title}>{title}</h2>
    {/*
     // @ts-expect-error TS2551 non-existing className */}
    <div className={styles.totals__amount}>{formatFn(value ?? 0)}</div>
    {/*
     // @ts-expect-error TS2551 non-existing className */}
    <div className={styles.totals__update}>
      last update {formatTime(lastUpdate)}
    </div>
  </div>
);

export const BillingTotals = ({
  amountDue,
  total,
  crawlRanking,
  aiUsage,
  lastUpdate,
  fullWidth = false,
}: BillingTotalsProps) => {
  const cards: TotalCardProps[] = [
    {
      title: "Amount Due",
      value: amountDue,
      lastUpdate,
      formatFn: (v) => formatPrice(v, { input: "cents" }),
    },
    {
      title: "Total",
      value: total,
      lastUpdate,
      formatFn: (v) => formatPrice(v, { input: "cents" }),
    },
    {
      title: "Crawl Ranking",
      value: crawlRanking,
      lastUpdate,
      formatFn: (v) => formatPrice(v),
    },
    {
      title: "AI Engine Usage",
      value: aiUsage,
      lastUpdate,
      formatFn: (v) => formatPrice(v),
    },
  ];

  return (
    // @ts-expect-error TS2551 non-existing className
    <div className={clsx(styles.totals, fullWidth && styles.totals__full)}>
      {cards.map((card) => (
        <TotalCard key={card.title} {...card} />
      ))}
    </div>
  );
};
